<template>
    <form id="fm_credit_card" class="form-horizontal px-1">
        <div id="signature-section">
            <div class="row-fluid">
                <ul
                    class="sigNav nav nav-tabs subnavbar"
                    style="margin-bottom: 10px;"
                >
                    <li class="drawIt">
                        <a href="#draw-it">
                            <i class="cus-pencil"></i>Draw It
                        </a>
                    </li>
                    <li class="typeIt">
                        <a href="#type-it">
                            <i class="cus-keyboard"></i>Type It
                        </a>
                    </li>
                </ul>
                <div class="draw-panel">
                    <input
                        id="output"
                        type="hidden"
                        name="output"
                        class="output"
                    />
                </div>
                <div class="type-panel form-row form-group">
                    <label for="card_number" class="col-3 col-form-label"
                        >Name:</label
                    >
                    <div class="bv-no-focus-ring col">
                        <input
                            id="fm_credit_card_name"
                            name="fm_credit_card_name"
                            type="text"
                            v-model="typed"
                            class="form-control name col-12"
                            style=""
                            @input="typeToCanvas"
                        />
                    </div>
                </div>
                <div class="typed d-none"></div>
                <canvas
                    id="canvas"
                    class="pad"
                    width="463"
                    height="150"
                ></canvas>
            </div>
        </div>
    </form>
</template>
<script>
import "@/jquery/signature/jquery.signaturepad.js";
import "@/css/signature/jquery.signaturepad.css";

export default {
    data: () => {
        return {
            typed: ""
        };
    },
    methods: {
        typeToCanvas(event) {
            var canvas = document.getElementById("canvas");
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.fitTextOnCanvas(event.target.value, ctx, canvas);
            ctx.fillStyle = "blue";
            ctx.textAlign = "left";
            this.$emit("input", canvas.toDataURL("image/png"));
        },
        fitTextOnCanvas(text, context, canvas) {
            // start with a large font size
            var fontsize = 130;

            // lower the font size until the text fits the canvas
            do {
                fontsize--;
                context.font = fontsize + "px 'Journal',Georgia,Times,serif";
            } while (context.measureText(text).width > canvas.width);

            // draw the text
            context.fillText(text, 5, (canvas.height * 3) / 4);
        },
        clear() {
            var canvas = document.getElementById("canvas");
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.$emit("input", canvas.toDataURL("image/png"));
            $("[name=fm_credit_card_name]").val("");
        }
    },
    mounted() {
        let self = this;
        $("#fm_credit_card").signaturePad({
            defaultAction: "drawIt",
            drawOnly: false,
            clear: $(".clearButton"),
            lineWidth: 0,
            lineTop: 150,
            validateFields: true,
            penColour: "#00F",
            penWidth: 4,
            onDrawEnd() {
                self.$emit("input", this.getSignatureImage());
            }
        });

        $(".typeIt").click(function () {
            $("div.type-panel").show();
            $("div.draw-panel").hide();
            $("[name=fm_credit_card_name]").prop(
                "class",
                "form-control name col-12"
            );
            $("#output").prop("class", "output");
            $("[name=fm_credit_card_name]").prop("disabled", false);
            $("[name=fm_credit_card_name]").focus();
        });

        $(".drawIt").click(function () {
            $("div.draw-panel").show();
            $("div.type-panel").hide();
            $("[name=fm_credit_card_name]").prop("class", "name");
            $("#output").prop("class", "output required");
            $("[name=fm_credit_card_name]").prop(
                "style",
                "background-color: none;"
            );
            $("[name=fm_credit_card_name]").prop("disabled", true);
            $("[name=fm_credit_card_name]").val("");
        });

        $(".drawIt").trigger("click");
    }
};
</script>
